import router, { RouterEvent } from '../router/router';
import Wix, { subscribe } from './Wix';

import viewerStateToRouteState from '../router/utils/viewerStateToRouteState';
import routeStateToViewerState from '../router/utils/routeStateToViewerState';
import { TPAViewMode } from '@wix/podcasts-common/dist/tpa';

async function scrollToWidgetTop() {
  // Wix.scrollTo fails in any other view mode
  if (
    [TPAViewMode.SITE, TPAViewMode.EDITOR_PREVIEW].includes(
      Wix.Utils.getViewMode(),
    )
  ) {
    try {
      const { rect, offsets } = await Wix.getBoundingRectAndOffsets();
      Wix.scrollTo(-rect.left, offsets.y);
    } catch (e) {
      Wix.scrollTo(0, 0);
    }
  }
}

function syncRouterWithViewer() {
  const unsubscribeViewerState = subscribe(
    Wix.Events.STATE_CHANGED,
    ({ newState }) => {
      const routeState = viewerStateToRouteState(newState);
      if (router.state !== routeState) {
        router.pushState(routeState);
      }
    },
  );
  const unsubscribeRouterState = router.subscribeState(() => {
    Wix.pushState(routeStateToViewerState(router.state));
  });

  const unsubscribeRouterRouteChanged = router.on(
    RouterEvent.ROUTE_CHANGE_COMPLETED,
    () => {
      void scrollToWidgetTop();
    },
  );

  return () => {
    unsubscribeViewerState();
    unsubscribeRouterState();
    unsubscribeRouterRouteChanged();
  };
}

export default syncRouterWithViewer;
